import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';

const ProfileMenu = ({ isOpen, onToggle, onSettings, onLogout }) => {
  const { profile, user } = useAuth();
  const [displayName, setDisplayName] = useState(
    localStorage.getItem('displayName') || ''
  );

  useEffect(() => {
    const handleDisplayNameChange = () => {
      setDisplayName(localStorage.getItem('displayName') || '');
    };
    window.addEventListener('displayNameChanged', handleDisplayNameChange);
    return () =>
      window.removeEventListener('displayNameChanged', handleDisplayNameChange);
  }, []);

  // Priority: localStorage override → profiles.full_name → Supabase display_name metadata → email
  const name =
    displayName ||
    profile?.full_name ||
    user?.user_metadata?.full_name ||
    user?.user_metadata?.name ||
    profile?.email ||
    user?.email ||
    'User';

  const avatarText = name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="profile-menu">
      <button className="profile-button" onClick={onToggle}>
        <span className="avatar">{avatarText || 'U'}</span>
        <span className="profile-name">{name}</span>
        <span className="chevron">▾</span>
      </button>
      {isOpen ? (
        <div className="profile-dropdown">
          <button type="button" onClick={onSettings}>
            Settings
          </button>
          <button type="button" onClick={onLogout}>
            Logout
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default ProfileMenu;
